import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Stack, Alert } from '@mui/material';
import Input from '../components/Input';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [showError, setShowError] = React.useState('');
  const [rememberMe, setRememberMe] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    
    const result = await login(
      data.get('username'),
      data.get('password'),
      rememberMe
    );

    if (result.success) {
      navigate('/dashboard');
    } else {
      setShowError(result.error || 'Failed to login');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid #ccc',
          borderRadius: '10px',
          padding: '20px',
          bgcolor: (theme) => theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.9)'  // Light mode: almost white
            : 'rgba(35, 35, 35, 0.9)',    // Dark mode: lighter dark shade
          boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        {showError && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {showError}
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Input
            margin="normal"
            spellCheck="false"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            disabled={loading}
          />
          <Input
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            disabled={loading}
          />
          <FormControlLabel
            control={
              <Checkbox 
                value="remember" 
                color="primary" 
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
            }
            label="Remember me"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
          <Stack spacing={1} alignItems="center">
            <Link to="/forgot-password">
              Forgot password?
            </Link>
            <Link to="/register">
              Don't have an account? Sign Up
            </Link>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}
